<template>
    <div class="addr-dropdown" ref="dropdown">
        <slot/>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        name: 'base-dropdown',
        data(){
            return{

            }
        },
        mounted(){
            // 下拉DOM插入到文档底部
            document.body.appendChild(this.$el);
        },
        beforeDestroy(){
            document.body.removeChild(this.$el);
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/datepicker/addr-dropdown.vue